/**
 * Copyright (c) 2017 hustcc
 * License: MIT
 * Version: v1.0.2
 * GitHub: https://github.com/hustcc/evenly
**/
!function (o, e) {
  "object" == typeof module && module.exports ? (module.exports = e(o), module.exports.default = module.exports) : o.evenly = e(o);
}("undefined" != typeof window ? window : this, function () {
  return function (o, e, t) {
    void 0 === t && (t = 2);
    var n = Math.pow(10, t);
    o *= n;
    for (var u = Math.floor(o / e), r = o - u * e, d = [], f = 0; ++f && f <= e;) d.push((f <= r ? u + 1 : u) / n);
    return d;
  };
});